<template>
  <section class="metrics-grid mb-8 mt-8">
    <kpi-card v-for="kpi in visible_kpis" :key="kpi.label" :kpi="kpi" />
  </section>
</template>

<script>
import KpiCard from '@/components/analytics/kpi-card.vue';

export default {
  name: 'KpiGrid',

  components: {
    KpiCard,
  },

  props: {
    kpis: {
      type: Array,
      required: true,
      default: () => [],
    },

    show_zero_values: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    visible_kpis() {
      if (this.show_zero_values) {
        return this.kpis;
      }

      return this.kpis.filter(kpi => {
        const value_str = kpi.value
          .toString()
          .replace(/,/g, '')
          .replace(/%/g, '')
          .replace(/\$/g, '');
        const numeric_value = parseFloat(value_str);
        return numeric_value && numeric_value > 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
}

@media (max-width: 768px) {
  .metrics-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
  }
}
</style>
